import {Component, Inject, OnInit} from '@angular/core';
import {MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA, MatLegacySnackBarRef as MatSnackBarRef} from '@angular/material/legacy-snack-bar';

@Component({
  selector: 'ngc-test-connection-snackbar',
  templateUrl: './test-connection-snackbar.component.html',
  styleUrls: ['./test-connection-snackbar.component.scss']
})
export class TestConnectionSnackbarComponent implements OnInit {

    message: string;
    debugMode: boolean;

    constructor(public snackBarRef: MatSnackBarRef<TestConnectionSnackbarComponent>,
                @Inject(MAT_SNACK_BAR_DATA)
                public data: {
                    message: string,
                    debugMode: boolean
                }) {
        this.message = data.message;
        this.debugMode = data.debugMode;
    }

    ngOnInit() {
    }

    onDebug() {
        if (this.snackBarRef) {
            this.snackBarRef.dismissWithAction();
        }
    }
}
